export const GANG_ACTIVE = ["trial", "active"];

/** A store honors Gang discounts only if it opted in. Missing store = our own catalog. */
export const honorsGang = (store) => {
    if (!store) return true;
    return Boolean(store.crew_perks ?? store.crew_perks_honored ?? false);
};

/** lines: [{ amount, dtf }] */
export function lineSavings(tier, lines) {
    if (!tier) return 0;
    return (lines || []).reduce(
        (s, l) => s + (l.amount || 0) * ((l.dtf ? tier.dtf_pct : tier.sitewide_pct) || 0) / 100,
        0
    );
}

/** Smart pick: the tier that leaves the most money in their pocket on THIS cart size. */
export function bestGangTier(tiers, lines) {
    let best = null;
    (tiers || []).forEach((t) => {
        const saved = lineSavings(t, lines);
        const cost = t.first_month ?? t.price_month ?? 0;
        const net = saved - cost;
        if (!best || net > best.net + 0.001 || (Math.abs(net - best.net) < 0.001 && saved > best.saved)) {
            best = { tier: t, saved, cost, net };
        }
    });
    return best;
}

export const cartGangLines = (items) =>
    (items || [])
        .filter((it) => honorsGang(it.store))
        .map((it) => ({ amount: it.line_total || 0, dtf: it.selections?.kind === "dtf" }));
